import { throwErrorMessage } from 'dashboard/store/utils/api';

// Contador de escritas por store (create/update/delete que deram certo). O
// `get` da lista SUBSTITUI os registros; se uma escrita terminou enquanto ele
// estava no ar, a resposta é uma foto de antes dela e apagaria o que a escrita
// acabou de pôr na tela — no Studio › Ferramentas a ferramenta criada antes de
// a lista inicial chegar sumia até o F5, e o consultor criava de novo
// (Atlas #33). Nesse caso a resposta é descartada e a lista é pedida de novo.
//
// simplificação: só o create/update/delete do factory contam. Action própria
// que escreve e faz commit (scenarios update/delete, inboxes delete, flows
// compile/duplicate, projects restore, responses bulk) segue com a corrida —
// expor o tracker a elas quando uma dessas telas mostrar o sintoma.
export const createWriteTracker = () => ({ count: 0 });

export const getRecords = (mutationTypes, API, writes = createWriteTracker()) =>
  async function fetchList({ commit }, params = {}) {
    commit(mutationTypes.SET_UI_FLAG, { fetchingList: true });
    let payload;
    let stale = false;
    try {
      const writesBefore = writes.count;
      const response = await API.get(params);
      stale = writes.count !== writesBefore;
      if (!stale) {
        commit(mutationTypes.SET, response.data.payload);
        commit(mutationTypes.SET_META, response.data.meta);
        payload = response.data.payload;
      }
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { fetchingList: false });
    }
    // Fora do try: um erro do novo pedido já sai embrulhado pelo catch dele,
    // e embrulhar de novo virava "Error: Error: ...".
    return stale ? fetchList({ commit }, params) : payload;
  };

export const showRecord =
  (mutationTypes, API) =>
  async ({ commit }, id) => {
    commit(mutationTypes.SET_UI_FLAG, { fetchingItem: true });
    try {
      const response = await API.show(id);
      // UPSERT (não ADD): `show` é fetch de 1 registro — se já está na lista
      // (comum após `get`), atualiza em vez de empurrar duplicata. ADD/push
      // duplicava o registro a cada show (ex.: dropdown de agentes no builder).
      commit(mutationTypes.UPSERT, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { fetchingItem: false });
    }
  };

export const createRecord =
  (mutationTypes, API, writes = createWriteTracker()) =>
  async ({ commit }, dataObj) => {
    commit(mutationTypes.SET_UI_FLAG, { creatingItem: true });
    try {
      const response = await API.create(dataObj);
      commit(mutationTypes.UPSERT, response.data);
      writes.count += 1;
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { creatingItem: false });
    }
  };

export const updateRecord =
  (mutationTypes, API, writes = createWriteTracker()) =>
  async ({ commit }, { id, ...updateObj }) => {
    commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
    try {
      const response = await API.update(id, updateObj);
      commit(mutationTypes.EDIT, response.data);
      writes.count += 1;
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
    }
  };

export const deleteRecord =
  (mutationTypes, API, writes = createWriteTracker()) =>
  async ({ commit }, id) => {
    commit(mutationTypes.SET_UI_FLAG, { deletingItem: true });
    try {
      await API.delete(id);
      commit(mutationTypes.DELETE, id);
      writes.count += 1;
      return id;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { deletingItem: false });
    }
  };
